<template>
  <div>
    <CusDatePicker ref="pay_date_select" v-model="pay_date"></CusDatePicker>

    <div
      style="position: fixed; top: 0; left: 0; right: 0; z-index: 999"
      class="payment"
    >
      <van-nav-bar :title="pageTitle" @click-left="goBack" left-arrow>
      </van-nav-bar>
    </div>

    <div style="padding-top: 46px">
      <div class="info-title">凭证信息</div>

      <div
        class="form-info-panel"
        style="padding-left: 0.4rem; text-align: left"
      >
        <div class="cus-row cus-row-v-m">
          <div class="cus-row-col-3"><span class="input-tag">类型</span></div>
          <div class="cus-row-col-9 select-line">
            <select
              v-model="payment_type"
              class="line-select"
              style="padding: 0"
              :disabled="isEdit"
            >
              <option value="1001">银行水单</option>
              <option value="1002">刷卡水单/扫码</option>
              <option value="1003">内转单</option>
            </select>
          </div>
        </div>
      </div>

      <div class="info-title">凭证文件</div>

      <div class="form-info-panel" style="padding: 0.4rem; text-align: left">
        <div
          v-for="(item, index) in confirm_proofs"
          :key="item"
          style="padding-bottom: 24px"
        >
          <div style="position: relative">
            <div style="font-size: 14px; font-weight: bold">
              {{ getFileNameFromUrl(item) }}
            </div>
            <div style="font-size: 12px; margin-top: 6px">
              上传类型：{{
                isPdfUrl(item) ? "pdf" : isDocxUrl(item) ? "docx" : "image"
              }}
            </div>
            <div style="font-size: 12px; margin-top: 6px">
              <FileSizeCheck :url="item" :limit="8" />
            </div>

            <div
              style="
                position: absolute;
                right: 0;
                font-size: 22px !important;
                top: 50%;
                transform: translateY(-50%);
                color: #1889f9 !important;
                display: flex;
                gap: 8px;
              "
            >
              <!-- 如果是图片类型，添加查看按钮 -->
              <van-icon
                v-if="!isPdfUrl(item) && !isDocxUrl(item)"
                name="eye-o"
                style="
                  display: inline-block;
                  vertical-align: middle;
                  font-size: 22px !important;
                  color: #1889f9 !important;
                  cursor: pointer;
                "
                @click.stop="previewConfirmProof(item)"
              />
              <van-icon
                name="delete"
                style="
                  display: inline-block;
                  vertical-align: middle;
                  font-size: 22px !important;
                  color: #1889f9 !important;
                  cursor: pointer;
                "
                @click.stop="deleteConfirmProof(index)"
              />
            </div>
          </div>
        </div>

        <a
          style="
            display: inline-block;
            width: 100%;
            border-radius: 0.125rem;
            line-height: 0.7rem;
            font-family: PingFangSC-Regular;
            font-size: 0.3rem;
            color: #1889f9;
            border: 1px solid #9f9f9f;
            text-align: center;
            position: relative;
          "
          href="javascript:void(0);"
          v-bind:class="{ inEdit: !nextStepValid }"
        >
          <van-icon
            name="add-o"
            style="
              display: inline-block;
              margin-right: 6px;
              vertical-align: middle;
            "
          />
          <span style="display: inline-block; vertical-align: middle"
            >上传文件</span
          >

          <input
            type="file"
            style="
              position: absolute;
              z-index: 999;
              top: 0;
              right: 0;
              bottom: 0;
              left: 0;
              opacity: 0;
            "
            accept="application/pdf,.docx,image/*"
            @change="getConfirmProofFile"
            ref="uploadConfirm"
          />
        </a>
      </div>

      <div class="info-title" v-if="isEdit">基本信息（只读）</div>

      <div
        v-if="isEdit"
        class="form-info-panel"
        style="padding-left: 0.4rem; text-align: left"
      >
        <div class="cus-row cus-row-v-m">
          <div class="cus-row-col-3">
            <span class="input-tag">内部收款号</span>
          </div>
          <div class="cus-row-col-9 select-line">
            <div class="line-input">{{ payment_bill_no }}</div>
          </div>
        </div>

        <div class="barrie-line"></div>

        <div class="cus-row cus-row-v-m" v-if="staff_name">
          <div class="cus-row-col-3">
            <span class="input-tag">业务员</span>
          </div>
          <div class="cus-row-col-9 select-line">
            <div class="line-input">
              {{ staff_name }}{{ staff_mobile ? " - " + staff_mobile : "" }}
            </div>
          </div>
        </div>

        <div class="barrie-line" v-if="staff_name"></div>

        <div class="cus-row cus-row-v-m">
          <div class="cus-row-col-3">
            <span class="input-tag">内部状态</span>
          </div>
          <div class="cus-row-col-9 select-line">
            <div class="line-input">{{ payment_status_txt }}</div>
          </div>
        </div>

        <div class="barrie-line" v-if="parseInt(is_urgent) === 1"></div>

        <div class="cus-row cus-row-v-m" v-if="parseInt(is_urgent) === 1">
          <div class="cus-row-col-3">
            <span class="input-tag">加急状态</span>
          </div>
          <div class="cus-row-col-9 select-line">
            <div
              class="line-input"
              style="display: inline-flex; align-items: center"
            >
              <span
                style="
                  display: inline-flex;
                  align-items: center;
                  background: #fff1f0;
                  color: #cf1322;
                  border-radius: 999px;
                  line-height: 22px;
                  padding: 0 10px;
                  font-size: 12px;
                "
              >
                <van-icon name="fire-o" style="margin-right: 4px" />已加急
              </span>
              <span
                v-if="urgent_applied_at"
                style="margin-left: 8px; color: #999; font-size: 12px"
                >（{{ urgent_applied_at }}）</span
              >
            </div>
          </div>
        </div>

        <div class="barrie-line" v-if="payment_status == 3"></div>

        <div class="cus-row cus-row-v-m" v-if="payment_status == 3">
          <div class="cus-row-col-3">
            <span class="input-tag">不通过原因</span>
          </div>
          <div class="cus-row-col-9 select-line">
            <div class="line-input">{{ payment_audit_remark || "-" }}</div>
          </div>
        </div>

        <div class="barrie-line" v-if="parseInt(payment_status) === 6"></div>

        <div class="cus-row cus-row-v-m" v-if="parseInt(payment_status) === 6">
          <div class="cus-row-col-3">
            <span class="input-tag">失败原因</span>
          </div>
          <div class="cus-row-col-9 select-line">
            <div class="line-input">{{ payment_audit_remark || "-" }}</div>
          </div>
        </div>

        <div class="barrie-line" v-if="showReceiptRow"></div>

        <div class="cus-row cus-row-v-m" v-if="showReceiptRow">
          <div class="cus-row-col-3">
            <span class="input-tag">收款凭证</span>
          </div>
          <div class="cus-row-col-9 select-line">
            <div
              class="line-input"
              style="color: #1889f9"
              @click="previewReceipt"
            >
              点击查看
            </div>
          </div>
        </div>
      </div>

      <div class="info-title">付款方信息</div>

      <div
        class="form-info-panel"
        style="padding-left: 0.4rem; text-align: left"
      >
        <div>
          <!-- 关联合同信息 -->
          <div class="cus-row cus-row-v-m">
            <div class="cus-row-col-3">
              <span class="input-tag">关联合同</span>
            </div>
            <div class="cus-row-col-9 select-line">
              <input
                class="line-input2"
                :placeholder="contractPlaceholder"
                readonly
                @click="openContractPicker"
                :value="selected_contract_text"
              />
            </div>
          </div>

          <!-- 付款单位信息 -->
          <div class="barrie-line"></div>

          <div class="cus-row cus-row-v-m">
            <div class="cus-row-col-3">
              <span class="input-tag">付款单位</span>
            </div>
            <div class="cus-row-col-9 select-line">
              <input
                class="line-input"
                placeholder="请输入付款单位名称"
                v-model="pay_company_name"
              />
            </div>
          </div>

          <!-- 付款日期信息 -->
          <div class="barrie-line"></div>

          <div class="cus-row cus-row-v-m">
            <div class="cus-row-col-3">
              <span class="input-tag">付款日期</span>
            </div>
            <div class="cus-row-col-9 select-line">
              <!-- <input
                class="line-input"
                type="text"
                style=""
                placeholder="必填"
                readonly
                onfocus="this.blur()"
                :value="
                  $refs.pay_date_select ? $refs.pay_date_select.dateStr : ''
                "
                @click="$refs.pay_date_select.doSelect()"
              /> -->

              <input
                class="line-input"
                type="text"
                style=""
                placeholder="必填"
                readonly
                onfocus="this.blur()"
                :value="
                  $refs.pay_date_select ? $refs.pay_date_select.dateStr : ''
                "
                @click="triggerPayDateSelect()"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="info-title">收款方信息</div>

    <div class="form-info-panel" style="padding-left: 0.4rem; text-align: left">
      <div class="cus-row cus-row-v-m">
        <div class="cus-row-col-3"><span class="input-tag">币种</span></div>
        <div class="cus-row-col-9 select-line">
          <select
            v-model="currency_code"
            class="line-select"
            style="padding: 0"
            :disabled="isConfirmType"
          >
            <option disabled value="">请选择</option>
            <option
              v-for="c in filteredCurrencyList"
              :key="c.quote_code"
              :value="c.quote_code"
            >
              {{ c.quote_code }}{{ c.name ? " - " + c.name : "" }}
            </option>
          </select>
        </div>
      </div>

      <div class="barrie-line"></div>

      <div class="cus-row cus-row-v-m">
        <div class="cus-row-col-3"><span class="input-tag">金额</span></div>
        <div class="cus-row-col-9 select-line">
          <input
            class="line-input"
            placeholder="请输入"
            v-model="price"
            type="number"
          />
        </div>
      </div>
    </div>

    <div
      class="in-bl-line"
      style="padding: 0 0.5rem; margin-top: 0.5rem; margin-bottom: 2rem"
      v-if="!isEdit"
    >
      <a
        class="bt"
        href="javascript:void(0);"
        v-on:click="nextStep"
        v-bind:class="{ inEdit: !nextStepValid }"
        >确定</a
      >
    </div>

    <div style="height: 20px"></div>

    <van-image-preview v-model="show" :images="images" @change="onChange">
    </van-image-preview>

    <!-- 选择关联合同弹层 -->
    <ContractPicker
      v-model="showContractPicker"
      @selected="onContractSelected"
    />

    <van-overlay :show="isRecognizing" v-if="!isEdit">
      <div
        style="
          display: flex;
          justify-content: center;
          align-items: center;
          height: 100%;
        "
      >
        <van-loading size="24px" vertical>识别中...</van-loading>
      </div>
    </van-overlay>

    <!-- 详情页撤销按钮 -->
    <div
      class="in-bl-line"
      style="padding: 0 0.5rem; margin-top: 0.5rem; margin-bottom: 16px"
      v-if="isEdit && canRevoke"
    >
      <a
        class="revoke-btn"
        href="javascript:void(0);"
        v-on:click="revokePayment"
        >撤销</a
      >
    </div>

    <!-- 详情页加急按钮 -->
    <!-- <div
      class="in-bl-line"
      style="padding: 0 0.5rem; margin-top: 0.2rem; margin-bottom: 3rem"
      v-if="isEdit && canUrgent"
    >
      <a class="urgent-btn" href="javascript:void(0);" v-on:click="applyUrgent"
        >加急审核</a
      >
    </div> -->

    <div style="height: 10px"></div>
  </div>
</template>


<script>
import common from "../assets/js/common";

import ContractPicker from "../components/ContractPicker";
import FileSizeCheck from "../components/FileSizeCheck.vue";
import store from "../store";
import axios from "axios";
import { Dialog } from "vant";
import CusDatePicker from "../modules/cus_date_picker";

export default {
  name: "HelloWorld",
  props: {
    msg: String,
  },
  components: {
    CusDatePicker,
    ContractPicker,
    FileSizeCheck,
  },
  data: function () {
    return {
      showPayDateSelect: true,
      begin_time: "",
      price: "",
      currency_code: "CNY",
      currency_list: [],
      payment_type: "1",
      pay_username: "",
      pay_company_name: "",
      collection_username: "",
      pay_date: "",
      faceImg: "",
      nextLock: "",
      show: false,
      payment_bill_no: "",
      payment_status: "",
      payment_audit_remark: "",
      pay_receipt_path: "",
      confirm_proofs: [],
      is_urgent: 0,
      urgent_applied_at: "",
      staff_name: "",
      staff_mobile: "",
      images: [],
      showContractPicker: false,
      selected_contract: null,
      contract_no: "",
      isRecognizing: false,
    };
  },
  methods: {
    triggerPayDateSelect() {
      this.$refs.pay_date_select.doSelect();
    },
    openContractPicker() {
      this.showContractPicker = true;
    },
    onContractSelected(item) {
      this.selected_contract = item;
    },
    isPdfUrl(url) {
      return /\.pdf$/i.test(url || "");
    },
    isDocxUrl(url) {
      return /\.docx$/i.test(url || "");
    },
    getFileNameFromUrl(url) {
      try {
        var parsedUrl = new URL(url);
        var pathname = parsedUrl.pathname;
        return pathname.substring(pathname.lastIndexOf("/") + 1);
      } catch (e) {
        return url;
      }
    },
    deleteConfirmProof(index) {
      this.confirm_proofs.splice(index, 1);
    },
    previewConfirmProof(url) {
      // 预览凭证文件图片
      const imageUrl = url.indexOf("http") === 0 ? url : common.dynamicHost() + url;
      this.images = [imageUrl];
      this.show = true;
    },
    performAiRecognition(imageUrl) {
      this.isRecognizing = true;
      axios
        .post(common.dynamicHost() + "/aicollectioninfo.php", {
          image_url: imageUrl,
        })
        .then((response) => {
          this.isRecognizing = false;
          const result = response.data;

          console.log("=== AI识别接口返回结果 ===");
          console.log("完整result:", result);

          if (result && result.status === 1 && result.data) {
            const data = result.data;
            console.log("解析的data:", data);

            if (data.ai_success) {
              // AI解析成功，自动填充表单
              console.log("开始填充表单...");
              if (data.payer_name) {
                this.pay_company_name = data.payer_name;
              }
              if (data.payment_date) {
                this.pay_date = data.payment_date;
              }
              if (data.payment_amount) {
                this.price = parseFloat(data.payment_amount);
              }
              console.log("表单填充完成");

              common.mAlert(this, "图片识别成功，已自动填充表单");
            } else {
              // AI解析失败
              common.mAlert(this, "AI解析失败，请手动填写表单信息");
            }
          } else {
            common.mAlert(
              this,
              (result && result.errmsg) || "图片识别完成，但未能提取到有效信息"
            );
          }
        })
        .catch((error) => {
          this.isRecognizing = false;
          console.error("AI recognition error:", error);
          common.mAlert(this, "图片识别失败，请重试");
        });
    },
    getConfirmProofFile() {
      const inputFile =
        this.$refs.uploadConfirm && this.$refs.uploadConfirm.files[0];
      if (!inputFile) {
        return;
      }
      var formData = new FormData();
      formData.append("file", inputFile);
      axios
        .post(common.dynamicHost() + "/upload.php", formData, {
          headers: { "Content-Type": "multipart/form-data" },
        })
        .then((res) => {
          this.$refs.uploadConfirm.value = "";
          res = res.data;
          if (res && res.errcode === 0) {
            this.confirm_proofs.push(common.dynamicHost() + res.path);

            //TODO 这里触发AI识别图片内容的功能，谢谢
            console.log("TODO 这里触发AI识别图片内容的功能，谢谢")
            this.performAiRecognition(common.dynamicHost() + res.path);

          } else {
            common.mAlert(this, "上传失败");
          }
        })
        .catch(() => {
          this.$refs.uploadConfirm.value = "";
          common.mAlert(this, "上传失败");
        });
    },
    goBack() {
      this.$router.push({ path: "/collection" });
    },
    paymentStatusText(s) {
      const map = {
        1: "待审核",
        2: "审核通过",
        3: "审核不通过",
        4: "已收款",
        5: "已撤销",
        6: "收款失败",
      };
      const k = parseInt(s);
      return map[k] || "";
    },
    previewReceipt() {
      if (!this.pay_receipt_path) {
        return;
      }
      const url =
        this.pay_receipt_path.indexOf("http") === 0
          ? this.pay_receipt_path
          : common.dynamicHost() + this.pay_receipt_path;
      this.$imagePreview
        ? this.$imagePreview([url])
        : window.open(url, "_blank");
    },
    showImage() {
      this.show = true;
    },
    nextStep() {
      if (this.nextLock) {
        return;
      }

      // 基本验证
      // if (!this.selected_contract) {
      //   common.mAlert(this, "请选择关联合同");
      //   return;
      // }

      if (!this.price) {
        common.mAlert(this, "金额不能为空");
        return;
      }

      if (!this.pay_company_name) {
        common.mAlert(this, "付款单位不能为空");
        return;
      }

      if (!this.pay_date) {
        common.mAlert(this, "付款日期不能为空");
        return;
      }

      // 凭证文件验证
      if (!this.confirm_proofs || this.confirm_proofs.length === 0) {
        common.mAlert(this, "请上传凭证文件");
        return;
      }

      this.nextLock = true;

      let params = {
        id: this.id || "",
        category: 1, // 1=收款
        type: this.payment_type, // 保持原有逻辑
        sub_type: this.payment_type, // 1=银行水单, 2=刷卡水单, 3=内转单
        price: this.price,
        currency_code: this.currency_code,
        pay_company_name: this.pay_company_name,
        pay_date: this.pay_date,
        confirm_proofs: JSON.stringify(this.confirm_proofs || []),
        contract_no: this.selected_contract ? (this.selected_contract.contract_numbe || this.selected_contract.bill_no) : (this.contract_no || ''),
      };

      common
        .cusHttp(
          this,
          "/admin_user.php?action=add_or_modify_payment",
          params,
          "post"
        )
        .then((res) => {
          this.nextLock = false;
          let data;
          try {
            data =
              typeof res.data === "string" ? JSON.parse(res.data) : res.data;
          } catch (e) {
            const text =
              res && res.data ? String(res.data).slice(0, 200) : "未知错误";
            common.mAlert(this, "提交失败：" + text);
            return;
          }
          if (data && (data.errcode == 0 || data.status === true)) {
            this.$router.push("/payment_success?category=1");
          } else {
            common.mAlert(
              this,
              (data && (data.errmsg || data.message)) || "提交失败"
            );
          }
        })
        .catch((err) => {
          this.nextLock = false;
          let msg = "";
          try {
            if (err && err.response && err.response.data) {
              msg =
                typeof err.response.data === "string"
                  ? err.response.data.slice(0, 200)
                  : JSON.stringify(err.response.data).slice(0, 200);
            }
          } catch (e) {
            /* no-op */
          }
          common.mAlert(this, "提交失败，请稍后重试" + (msg ? "：" + msg : ""));
        });
    },
    revokePayment() {
      if (!this.id) {
        return;
      }
      Dialog.confirm({
        title: "操作提醒",
        message: "确认要撤销当前收款吗?",
      })
        .then(() => {
          common
            .cusHttp(
              this,
              "/admin_user.php?action=payment_revoke",
              { id: this.id },
              "post"
            )
            .then((res) => {
              try {
                var data =
                  typeof res.data === "string"
                    ? JSON.parse(res.data)
                    : res.data;
                if (data && data.errcode === 0) {
                  common.mAlert(this, "撤销成功");
                  this.$router.replace("/collection");
                } else {
                  common.mAlert(this, (data && data.errmsg) || "撤销失败");
                }
              } catch (e) {
                common.mAlert(this, "撤销失败");
              }
            })
            .catch(() => {
              common.mAlert(this, "撤销失败");
            });
        })
        .catch(() => {});
    },
    applyUrgent() {
      if (!this.id) {
        return;
      }
      Dialog.confirm({
        title: "操作提醒",
        message: "确认要对本单发起加急审核吗?（每日最多3次）",
      })
        .then(() => {
          common
            .cusHttp(
              this,
              "/admin_user.php?action=payment_urgent",
              { id: this.id },
              "post"
            )
            .then((res) => {
              try {
                var data =
                  typeof res.data === "string"
                    ? JSON.parse(res.data)
                    : res.data;
                if (data && data.errcode === 0) {
                  common.mAlert(this, "已提交加急");
                  this.is_urgent = 1;
                } else {
                  common.mAlert(this, (data && data.errmsg) || "加急失败");
                }
              } catch (e) {
                common.mAlert(this, "加急失败");
              }
            })
            .catch(() => {
              common.mAlert(this, "加急失败");
            });
        })
        .catch(() => {});
    },
  },
  created: function () {
    /**
     * 如果没有token则跳到登录页哟
     */
    common.checkToken(this);

    common.setTitle("确认信息");
    this.id =
      this.$route && this.$route.query && this.$route.query.id
        ? this.$route.query.id
        : common.queryValue("id");
  },
  mounted() {
    this.$store.commit("setTarbarIndex", 1);
    //初始化数据
    if (store.state.chosenSupplier) {
      this.supplier_id = store.state.chosenSupplier.id;
      this.supplier_name = store.state.chosenSupplier.supplier_name;
      this.contact_name = store.state.chosenSupplier.contact_name;
      this.contact_phone = store.state.chosenSupplier.contact_phone;
      this.address = store.state.chosenSupplier.address;
      this.email = store.state.chosenSupplier.email;
      this.bank_account = store.state.chosenSupplier.bank_account;
      this.bank_account_name = store.state.chosenSupplier.bank_account_name;
      this.bank_name = store.state.chosenSupplier.bank_name;
    }

    // store.commit('setChosenSupplier','')

    // 如果是编辑场景，加载详情并回填（统一使用 admin_user 风格）
    if (this.id) {
      common
        .cusHttp(
          this,
          "/admin_user.php?action=payment_detail",
          { id: this.id },
          "get"
        )
        .then((res) => {
          try {
            const data =
              typeof res.data === "string" ? JSON.parse(res.data) : res.data;
            const payment =
              (data.data && data.data.payment) || data.payment || {};
            const supplier =
              (data.data && data.data.supplier) || data.supplier || {};
            const staff = (data.data && data.data.staff) || data.staff || {};

            // 收款类型（编辑态回填）
            if (payment.type !== undefined && payment.type !== null) {
              this.payment_type = String(payment.type);
            }

            // 收款专用字段回填
            this.pay_company_name = payment.pay_company_name || this.pay_company_name;
            this.pay_date = payment.pay_date || this.pay_date;
            this.price = payment.price || this.price;
            this.currency_code = payment.currency_code || this.currency_code;
            this.faceImg = payment.attachment || this.faceImg;
            // 如果有faceImg，设置到images数组中用于预览
            if (this.faceImg) {
              this.images = [common.dynamicHost() + this.faceImg];
            }
            this.contract_no = payment.contract_no || "";
            this.supplier_name = payment.supplier_name || this.supplier_name;
            this.contact_name = payment.contact_name || this.contact_name;

            // 外币收款字段回填
            this.foreign_account_region = payment.foreign_account_region || "";
            this.foreign_bank_address = payment.foreign_bank_address || "";
            this.foreign_account_currency =
              payment.foreign_account_currency || "";
            this.foreign_bank_name = payment.foreign_bank_name || "";
            this.foreign_account_name = payment.foreign_account_name || "";
            this.foreign_account_number = payment.foreign_account_number || "";
            this.foreign_swift_code = payment.foreign_swift_code || "";
            this.foreign_local_bank_code =
              payment.foreign_local_bank_code || "";
            this.foreign_postal_code = payment.foreign_postal_code || "";
            this.foreign_company_address =
              payment.foreign_company_address || "";

            // 外币证明文件
            if (payment.foreign_currency_proofs) {
              try {
                this.foreign_currency_proofs =
                  JSON.parse(payment.foreign_currency_proofs) || [];
              } catch (e) {
                this.foreign_currency_proofs = [];
              }
            }
            // 细分的外币证明文件
            if (payment.foreign_invoice_proofs) {
              try {
                this.foreign_invoice_proofs =
                  JSON.parse(payment.foreign_invoice_proofs) || [];
              } catch (e) {
                this.foreign_invoice_proofs = [];
              }
            }
            if (payment.foreign_qualification_proofs) {
              try {
                this.foreign_qualification_proofs =
                  JSON.parse(payment.foreign_qualification_proofs) || [];
              } catch (e) {
                this.foreign_qualification_proofs = [];
              }
            }
            if (payment.foreign_contract_proofs) {
              try {
                this.foreign_contract_proofs =
                  JSON.parse(payment.foreign_contract_proofs) || [];
              } catch (e) {
                this.foreign_contract_proofs = [];
              }
            }

            // 确认件证明文件
            if (payment.confirm_proofs) {
              try {
                this.confirm_proofs = JSON.parse(payment.confirm_proofs) || [];
              } catch (e) {
                this.confirm_proofs = [];
              }
            }

            // 只读基本信息
            this.payment_bill_no = payment.bill_no || "";
            this.payment_status = payment.status || "";
            this.payment_audit_remark =
              payment.audit_remark || payment.remark || "";
            this.pay_receipt_path = payment.pay_receipt_path || "";
            this.is_urgent = payment.is_urgent || 0;
            this.urgent_applied_at = payment.urgent_applied_at || "";

            // 业务员信息
            this.staff_name = staff.name || "";
            this.staff_mobile = staff.mobile || "";

            this.supplier_id = supplier.id || this.supplier_id;
            this.supplier_name = supplier.supplier_name || this.supplier_name;
            this.contact_name = supplier.contact_name || this.contact_name;
            this.contact_phone = supplier.contact_phone || this.contact_phone;
            this.address = supplier.address || this.address;
            this.email = supplier.email || this.email;

            if (this.contract_no) {
              this.selected_contract = {
                contract_numbe: this.contract_no,
                bill_no: this.contract_no,
              };
            }
          } catch (e) {
            /* no-op */
          }
        })
        .catch(() => {
          /* keep silent */
        });
    }

    // 加载币种列表
    common
      .cusHttp(this, "/admin_user.php?action=currency_list", {}, "get")
      .then((res) => {
        try {
          const data =
            typeof res.data === "string" ? JSON.parse(res.data) : res.data;
          if (data.errcode === 0) {
            this.currency_list = data.data || [];
            // 默认人民币
            if (!this.currency_code) {
              var hasCny =
                this.currency_list && this.currency_list.find
                  ? this.currency_list.find(function (i) {
                      return i.quote_code === "CNY";
                    })
                  : null;
              var firstCode =
                this.currency_list && this.currency_list.length > 0
                  ? this.currency_list[0].quote_code
                  : "";
              this.currency_code = hasCny ? "CNY" : firstCode;
            }
          }
        } catch (e) {
          /* no-op */
        }
      })
      .catch(() => {
        /* keep silent */
      });
  },
  watch: {
    payment_type(newVal) {
      // 当选择合同收款时，自动设置币种为CNY
      if (String(newVal) === "1") {
        this.currency_code = "CNY";
      }
      // 当选择部门间收款/供应商收款时，自动设置币种为CNY
      else if (String(newVal) === "2") {
        this.currency_code = "CNY";
      }
      // 当选择外币收款时，如果当前是人民币，清空币种选择
      else if (String(newVal) === "3" && this.currency_code === "CNY") {
        this.currency_code = "";
      }
    },
  },
  onShow() {},
  computed: {
    isEdit() {
      return !!this.id;
    },
    canRevoke() {
      // 待审核(1) 或 审核通过(2) 可撤销，加急订单也可以撤销
      const s = parseInt(this.payment_status);
      return this.isEdit && (s === 1 || s === 2);
    },
    pageTitle() {
      return this.isEdit ? "收款详情" : "新增收款";
    },
    isContractType() {
      return String(this.payment_type) === "1";
    },
    isConfirmType() {
      return String(this.payment_type) === "2";
    },
    isForeignType() {
      return String(this.payment_type) === "3";
    },
    nextStepValid: function () {
      return true;
    },
    facePath: function () {
      return common.dynamicHost() + this.faceImg;
    },
    payment_status_txt() {
      return this.paymentStatusText(this.payment_status);
    },
    showReceiptRow() {
      return (
        !!this.pay_receipt_path &&
        (parseInt(this.payment_status) === 2 ||
          parseInt(this.payment_status) === 4)
      );
    },
    canUrgent() {
      const s = parseInt(this.payment_status);
      // 待审核(1) 或 审核通过(2) 可加急；已加急或已收款则不再显示
      return (
        this.isEdit && (s === 1 || s === 2) && parseInt(this.is_urgent) !== 1
      );
    },
    selected_contract_text: function () {
      if (this.selected_contract) {
        return (
          this.selected_contract.contract_numbe ||
          this.selected_contract.bill_no ||
          ""
        );
      }
      return "";
    },
    contractPlaceholder: function () {
      return "请选择（非必填）";
    },
    pickSupplier() {
      return "";
    },
    filteredCurrencyList: function () {
      // 如果是外币收款类型，过滤掉人民币
      if (this.isForeignType) {
        return this.currency_list.filter((c) => c.quote_code !== "CNY");
      }
      // 如果是合同收款类型，只显示人民币
      if (this.isContractType) {
        return this.currency_list.filter((c) => c.quote_code === "CNY");
      }
      return this.currency_list;
    },
  },
};
</script>


<style>
html,
body {
  background-color: #f8f8f8 !important;
}

input::-webkit-input-placeholder {
  padding-top: 0;
  line-height: normal;
}

#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}

.inEdit {
  opacity: 0.4;
}

.disableText {
  color: #999999 !important;
}

.in-bl {
  display: inline-block;
}

.common-padding {
  padding: 0 0.625rem;
}
.common-padding2 {
  padding: 0.4rem 0.625rem;
}

.fc-aaaaaa-fs-nor-m {
  font-family: PingFangSC-Medium;
  font-size: 0.4375rem;
  color: #aaaaaa;
  line-height: 0.625rem;
}

.camera_text {
  line-height: 0.4rem;
  font-family: PingFangSC-Regular;
  font-size: 0.3rem;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 0rem;
  color: #1889f9;
}

.bank-desc {
  font-family: PingFangSC-Regular;
  font-size: 0.438rem;
  color: #111111;
  line-height: 0.625rem;
}

.ps-text {
  font-size: 0.22rem;
  line-height: 0.3rem;
  color: #666666;
}

/* 撤销按钮：弱化视觉，避免误触 */
.revoke-btn {
  display: inline-block;
  width: 100%;
  line-height: 0.7rem;
  border-radius: 0.125rem;
  font-size: 0.3rem;
  color: #666666;
  border: 1px solid #d9d9d9;
  background: #ffffff;
}

.urgent-btn {
  display: inline-block;
  width: 100%;
  line-height: 0.7rem;
  border-radius: 0.125rem;
  font-size: 0.3rem;
  color: #ff4d4f;
  border: 1px dashed #ff4d4f;
  background: #fffafa;
}
</style>